import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEnum, IsOptional } from 'class-validator';
import { VendorMathRoundingTypeEnum, VendorProviderEnum } from '../enum';
import { VendorExposeGroup } from '../interface';
export class CreateVendorMathDto {
}
__decorate([
    ApiProperty({ enum: VendorProviderEnum, description: 'Vendor provider', example: VendorProviderEnum.GOPARROT }),
    Expose({ groups: [VendorExposeGroup.READ, VendorExposeGroup.CREATE, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    IsOptional({ groups: [VendorExposeGroup.PATCH] }),
    IsEnum(VendorProviderEnum, { always: true }),
    __metadata("design:type", String)
], CreateVendorMathDto.prototype, "strategy", void 0);
__decorate([
    ApiProperty({ enum: VendorMathRoundingTypeEnum, description: 'Rounding strategy', example: VendorMathRoundingTypeEnum.HALF_EVEN }),
    Expose({ groups: [VendorExposeGroup.READ, VendorExposeGroup.CREATE, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    IsOptional({ groups: [VendorExposeGroup.PATCH] }),
    IsEnum(VendorMathRoundingTypeEnum, { always: true }),
    __metadata("design:type", String)
], CreateVendorMathDto.prototype, "roundingType", void 0);
//# sourceMappingURL=CreateVendorMathDto.js.map